var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('BaseAppLogo',{staticClass:"lg-block-hidden",attrs:{"width":"125","height":"32","type":"logo-full"}}),_vm._v(" "),_c('BaseAppLogo',{staticClass:"lg-hidden-block",attrs:{"width":"93","height":"24","type":"logo-name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }